import React from 'react';

import 'bootstrap/dist/css/bootstrap.css';
import './quotes-list.styl'

class QuotesList extends React.Component {
  render(){
    return (
      <ul className="quotes-list">
        { this.props.quotes.map(quote => {
            return (
              <li key={ quote.text }>
                <blockquote className="quotes-list__quote">
                  <p className="quotes-list__quote__text">{ quote.text }</p>
                  { (quote.author || quote.year) &&
                    <div className="quotes-list__quote__footer">
                      —
                      { quote.author &&
                        <span>{ quote.author }</span>
                      }
                      { quote.year &&
                        <span>{ quote.year }</span>
                      }
                    </div>
                  }
                </blockquote>
              </li>
            );
          })
        }
      </ul>
    );
  }
}

export default QuotesList;



// WEBPACK FOOTER //
// ./src/components/quotes-list/quotes-list.js